function HistoryModal(node) {
  if (!this instanceof HistoryModal) return new HistoryModal();

  const that = this;
  that.node = node;
  that.loadDescTimeout = null;
  that.dateIsValid = false;

  this.loadJson = function () {
    const xhr = new XMLHttpRequest();
    const that = this;
    xhr.open("GET", "content/history-modal.html", true);
    xhr.onreadystatechange = function () {
      if (this.readyState !== 4) return;
      if (this.status !== 200) return;

      const historyModal = that.node.querySelector(".history-modal");
      historyModal.insertAdjacentHTML("beforeend", this.responseText);

      that.initHandlers();
      that.loadData();
    };
    xhr.send();
  };

  this.initHandlers = function () {
    const closeButton = this.node.querySelector(".history-modal .close-button");
    closeButton.addEventListener("click", () => {
      this.toggleModal();
    });

    window.addEventListener("click", (event) => {
      this.windowOnClick(event);
    });

    const cancelButton = this.node.querySelector(
      ".history-modal .cancel-button"
    );
    cancelButton.addEventListener("click", () => {
      this.toggleModal();
    });

    const dateInput = this.node.querySelector(".date-input");
    const descInput = this.node.querySelector(".desc-input");

    dateInput.addEventListener("input", () => {
      const dateRegex = new RegExp(
        /^\s*(3[01]|[12][0-9]|0[1-9])\.(1[012]|0?[1-9])\.((?:19|20)\d{2})\s*$/g
      );
      if (dateRegex.test(dateInput.value)) {
        this.dateIsValid = true;
        this.searchValuesChanged();
      } else {
        this.dateIsValid = false;
      }

      if (dateInput.value.length === 0) {
        this.searchValuesChanged();
      }
    });

    descInput.addEventListener("input", this.searchValuesChanged);
  };

  this.searchValuesChanged = function () {
    const later = () => {
      this.loadDescTimeout = null;
      that.loadData();
    };

    clearTimeout(this.loadDescTimeout);
    this.loadDescTimeout = setTimeout(later, 1000);
  };

  this.toggleModal = function () {
    const modal = this.node.querySelector(".history-modal");
    if (modal.classList.toggle("show-modal")) {
      that.loadData();
    } else {
      const dateInput = this.node.querySelector(".date-input");
      const descInput = this.node.querySelector(".desc-input");
      dateInput.value = "";
      descInput.value = "";
    }
  };

  this.windowOnClick = function (event) {
    const modal = this.node.querySelector(".history-modal");
    if (event.target === modal) {
      this.toggleModal();
    }
  };

  that.loadData = function () {
    const dateInput = this.node.querySelector(".date-input");
    const descInput = this.node.querySelector(".desc-input");

    const url = `${API_PATH}automaticExport/historyData?date=${
      this.dateIsValid ? dateInput.value : ""
    }&search=${descInput.value.length > 0 ? descInput.value : ""}`;
    const xhr = Network.openXHR("GET", url);
    xhr.onerror = () => {
      snackbar.show({
        message: "Beim Laden der Historie ist ein Fehler aufgetreten",
      });
    };
    xhr.onreadystatechange = function () {
      if (xhr.readyState !== XMLHttpRequest.DONE) return;
      if (xhr.status === 200) {
        const historyData = JSON.parse(this.responseText);
        const tableBody = that.node.querySelector(".history-table-body");
        tableBody.innerHTML = "";

        historyData.map((data) => {
          const tr = document.createElement("tr");
          const nameTd = document.createElement("td");
          const countTd = document.createElement("td");
          const dateTd = document.createElement("td");

          nameTd.innerText = `${data.automaticexport[0].name} ${
            data.automaticexport[0].partner.name
              ? "(" + data.automaticexport[0].partner.name + ")"
              : ""
          }`;
          countTd.innerText = data.count;
          dateTd.innerText = data.date;
          tr.append(nameTd, countTd, dateTd);
          tableBody.appendChild(tr);
        });
      }
    };

    xhr.send();
  };
}
